<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-30 16:01:08
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-06-22 18:21:16
 * @Description: 流程图实例
-->

<template>
  <div ref="diagram" class="wrap bg">
    <div style="width: 0; height: 0; overflow: hidden">
      <svg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <marker
            id="sequenceflow-end-highlight"
            viewBox="0 0 20 20"
            refX="11"
            refY="10"
            markerWidth="10"
            markerHeight="10"
            orient="auto"
          >
            <path
              d="M 1 5 L 11 10 L 1 15 Z"
              style="
                fill: #b7eb8f;
                stroke-width: 1px;
                stroke-linecap: round;
                stroke-dasharray: 10000, 1;
                stroke: #b7eb8f;
              "
            ></path>
          </marker>
        </defs>
      </svg>
    </div>

    <el-row class="mb12" v-if="fullscreen">
      <el-col :span="6" class="center">
        <span>缩放</span>
        <el-slider
          class="slider"
          v-model="value1"
          @input="onSliderChanged"
          :max="4"
          :min="0.1"
          :step="0.1"
        ></el-slider>
      </el-col>
    </el-row>

    <div class="canvas" ref="pic">
      <a href="javascript:" @click="setFull" class="fullBtn" v-if="!fullscreen">
        全屏显示
      </a>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="100%"
        :class="[!fullscreen ? 'bg' : 'fullbg']"
      >
        <defs>
          <pattern
            id="30186a58-99fc-4e46-8b0a-ead7f3d3a9a4"
            patternUnits="userSpaceOnUse"
            patternTransform="matrix(1,0,0,1,0,0)"
            x="0"
            y="0"
            width="20"
            height="20"
            style="transition: all 0.1s ease 0s"
          >
            <rect
              width="2"
              height="2"
              rx="1"
              ry="1"
              fill="#ababab"
              opacity="1"
            ></rect>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          fill="url(#30186a58-99fc-4e46-8b0a-ead7f3d3a9a4)"
        ></rect>
      </svg>
      <div
        ref="canvas"
        :class="{ 'js-canvas': true, svgCanvas: fullscreen }"
        id="js-canvas"
      ></div>
    </div>
  </div>
</template>

<script>
import BpmnViewer from "bpmn-js/lib/Viewer";
import MoveCanvasModule from "diagram-js/lib/navigation/movecanvas";
import CustomRenderer from "./bpmn-renderer";
import { add, sub } from "@/utils/numberComputed";
import { setFullScreen, listenOutFullScreem } from "@/utils/fullScreen";

export default {
  props: {
    businessKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fullscreen: false,
      value1: 1,
      viewer: {},
      initXml: {
        xml: undefined,
        comment: undefined,
        highLight: undefined,
      },
    };
  },
  mounted() {
    this.onBindMouse();
    const _this = this;
    this.getXml().then(async (xml) => {
      let height = 500;
      if (document.body.clientWidth <= 800) {
        height = document.body.clientHeight - 250;
      }
      _this.viewer = new BpmnViewer({
        container: this.$refs.canvas,
        height: height,
        additionalModules: [
          MoveCanvasModule, // 移动整个画布,
          CustomRenderer,
        ],
      });
      _this.initXml.xml = xml;

      await _this.viewer.importXML(_this.initXml.xml);
      const canvas = _this.viewer.get("canvas");
      canvas.zoom("fit-viewport", "auto");
      _this.value1 = canvas.zoom();

      // 设置操作信息
      this.getComments().then((data) => {
        _this.initXml.comment = data;
        _this.setHover(_this.viewer, _this.initXml.comment);
      });

      // 设置高亮节点
      this.getHighLightedNodes().then((data) => {
        _this.initXml.highLight = data;
        _this.setHighLightedNodes(_this.viewer, _this.initXml.highLight);
      });
    });
  },
  beforeDestroy() {
    this.offBindMouse();
  },
  methods: {
    resetSvg() {
      this.viewer.clear();
      this.initSvg();
    },
    async initSvg() {
      const _this = this;
      await _this.viewer.importXML(_this.initXml.xml);
      const canvas = _this.viewer.get("canvas");
      canvas.zoom("fit-viewport", "auto");
      _this.value1 = canvas.zoom();

      // 设置操作信息
      _this.setHover(_this.viewer, _this.initXml.comment);

      // 设置高亮节点
      _this.setHighLightedNodes(_this.viewer, _this.initXml.highLight);
    },
    onBindMouse() {
      this.$refs.pic.addEventListener("mouseover", this.onCanvasScale);
      this.$refs.pic.addEventListener("mouseout", this.offBindMouse);
    },
    offBindMouse() {
      this.$refs.pic.removeEventListener("mouseover", this.onCanvasScale);
    },
    onCanvasScale() {
      const _this = this;
      window.onmousewheel = function (e) {
        if (e.wheelDelta) {
          // 判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) {
            _this.value1 = Math.max(add(_this.value1, 0.02), 0.1);
          }
          if (e.wheelDelta < 0) {
            _this.value1 = Math.min(sub(_this.value1, 0.02), 4);
          }
        } else if (e.detail) {
          // Firefox滑轮事件
          if (e.detail > 0) {
            _this.value1 = Math.max(add(_this.value1, 0.02), 0.1);
          }
          if (e.detail < 0) {
            _this.value1 = Math.min(sub(_this.value1, 0.02), 4);
          }
        }
      };
      this.offBindMouse();
    },
    setFull() {
      if (window.innerWidth > 800) {
        this.fullscreen = true;
        setFullScreen(this.$refs.diagram);
        const _this = this;
        listenOutFullScreem().then(() => {
          _this.resetSvg();
          _this.fullscreen = false;
        });
      } else {
        // iframe 情况
        window.parent.postMessage &&
          window.parent.postMessage("show_diagram_full_screen", "*");
        // 常规情况
        window.postMessage && window.postMessage("show_diagram_full_screen");
      }
    },
    // 获取流程定义XML
    getXml() {
      return new Promise((resolve) => {
        this.$http
          .get(
            `/help/workflow/auth/v1/historic-process-instances/${this.businessKey}/xml`,
            {
              params: { _noLoading: true }
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              resolve(res.data);
            }
          });
      });
    },
    // 获取流程图批注
    getComments() {
      return new Promise((resolve) => {
        this.$http
          .get(
            `/help/workflow/auth/v1/historic-process-instances/${this.businessKey}/diagram/comments`,
            {
              params: { _noLoading: true }
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              resolve(res.data);
            }
          });
      });
    },
    setHover(viewer, data) {
      const overlays = viewer.get("overlays");
      // 移入增加
      viewer.on("element.hover", function (event, ele) {
        if (
          [
            "bpmn:UserTask",
            // 'bpmn:StartEvent',
            // 'bpmn:EndEvent',
            // 'bpmn:ExclusiveGateway'
          ].indexOf(ele.element.type) === -1
        ) {
          return;
        }
        let res = null;
        data.reverse().some((item) => {
          if (item.taskKey === event.element.id) {
            res = item;
            return true;
          }
          return false;
        });
        if (res) {
          let position = {
            bottom: -6,
          };
          if (res.y > 400) {
            position = {
              top: -66,
            };
          }
          overlays.add(event.element.id, "note", {
            position,
            html: `
              <div class="popup-overlays ${res.y > 400 ? "top" : "bottom"}">
                <div class="inner">
                  <div>${res.editTask ? "创建人" : "操作人"} ：${
              res.userName || "-"
            }</div>
                  <div>操作结果：${res.resultName || "-"}</div>
                  <div>操作时间：${res.operateTime || "-"}</div>
                  <div class="${res.ccList ? "" : "hide-cc"}">抄送人 ：${
              res.ccList || "-"
            }</div>
                </div>
              </div>
            `,
          });
        }
      });
      // 移出清除
      viewer.on("element.out", function (event, ele) {
        if (
          [
            "bpmn:UserTask",
            // 'bpmn:StartEvent',
            // 'bpmn:EndEvent',
            // 'bpmn:ExclusiveGateway'
          ].indexOf(ele.element.type) === -1
        ) {
          return;
        }
        overlays.clear();
      });
    },
    // 获取高亮节点
    getHighLightedNodes() {
      return new Promise((resolve) => {
        this.$http
          .get(
            `/help/workflow/auth/v1/historic-process-instances/${this.businessKey}/high-lighted-nodes`,
            {
              params: { _noLoading: true }
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              resolve(res.data);
            }
          });
      });
    },
    // 设置高亮节点
    setHighLightedNodes(viewer, data) {
      const canvas = viewer.get("canvas");
      canvas.zoom("fit-viewport", "auto");
      const {
        highLightedActivities,
        highLightedSequenceFlows,
        currentUserTasks,
      } = data;
      // 历史活动节点
      highLightedActivities.forEach((item) => {
        canvas.addMarker(item, "highlight");
      });
      // 历史活动线
      highLightedSequenceFlows.forEach((item) => {
        canvas.addMarker(item, "line-highlight");
      });
      // 当前用户任务
      currentUserTasks.forEach((item) => {
        canvas.addMarker(item, "highlight-active");
      });
    },
    onSliderChanged(val) {
      this.viewer.get && this.viewer.get("canvas").zoom(val);
    },
  },
};
</script>

<style lang="scss">
.popup-overlays {
  border-radius: 4px;
  z-index: 2000;
  font-size: 12px;
  line-height: 1.2;
  min-width: 200px;
  background: #303133;
  color: #fff;

  &.top {
    .inner::after {
      display: none;
    }

    .inner::before {
      content: "";
      display: block;
      position: absolute;
      bottom: -5px;
      left: calc(50% - 2px);
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid #303133;
    }
  }
}

.popup-overlays .inner {
  position: relative;
  padding: 10px;

  > div {
    white-space: wrap;
    word-break: break-all;
  }
}

.popup-overlays .inner::after {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  left: calc(50% - 2px);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 6px solid #303133;
}

.bjs-powered-by {
  display: none;
}

body {
  font-family: "Arial", sans-serif;
}

.header input[type="text"] {
  width: 500px;
  max-width: 100%;
}

.console textarea {
  width: 100%;
  min-height: 80px;
  border: none;
  padding: 0;
}

.canvas {
  min-height: 500px;
  position: relative;
  border: 1px solid #e5e5e5;
  border-radius: 4px;

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: rgb(247, 249, 255);
  }

  .fullbg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100vh;
    background: rgb(247, 249, 255);
  }

  .js-canvas {
    position: relative;
    z-index: 2;
  }

  .svgCanvas {
    .djs-container {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100vh !important;
    }
  }
}

.highlight:not(.djs-connection) .djs-visual > :nth-child(1) {
  /* fill: #b7eb8f !important; */
  fill: rgb(191, 243, 195) !important;
  stroke: rgb(113, 203, 161) !important;
  /* color elements as green */
}

.highlight text tspan {
  fill: rgb(52, 94, 58) !important;
}

.line-highlight path {
  stroke: #b7eb8f !important;
}

.line-highlight .djs-visual path {
  marker-end: url(#sequenceflow-end-highlight) !important;
}

.highlight-active:not(.djs-connection) .djs-visual > :nth-child(1) {
  /* fill: #b7eb8f !important; */
  fill: #1e90ff !important;
  stroke: #015ca0 !important;
  /* color elements as green */
}

.highlight-active text tspan {
  fill: #fff !important;
}

@media screen and (max-width: 800px) {
  .wrap {
    max-height: 100%;

    .canvas {
      max-height: 100%;
      min-height: 0;
    }
  }
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 38px;

  span {
    margin-right: 12px;
  }

  .slider {
    width: calc(100% - 48px);
  }
}

.fullBtn {
  position: absolute;
  z-index: 100;
  right: 12px;
  top: 12px;
}

.mb12 {
  margin-bottom: 12px;
}

.bg {
  background: #fff;
}

.hide-cc {
  display: none;
}
</style>
